import en from './en.json';
import de from './de.json'

export const localizationData = {    
    'en': en,
    'de': de,
}